import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Hi, I'm Wakana Tsuji</h1>
            </header>
            <div className="content">
                <p>DESIGNER, PHOTOGRAPHER & PHD STUDENT AT OISE/UNIVERSITY OF TORONTO</p>
            </div>
        </div>
    </section>
)

export default Banner
